import React from 'react';
import { Container, Typography, Box, Paper, Divider, Link } from '@mui/material';

const ConsentPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Согласие на обработку персональных данных
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" gutterBottom>
          в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»
        </Typography>
        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" paragraph>
            <strong>Оператор:</strong> Индивидуальный предприниматель, осуществляющий деятельность под торговой маркой DomikTyumen (далее — «Оператор»)
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Адрес сайта:</strong> domik72.ru
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Контактный email:</strong> admin@domik72.ru
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Телефон:</strong> +7 (963) 060-02-55
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            1. Общие положения
          </Typography>
          <Typography variant="body1" paragraph>
            Настоящее Согласие на обработку персональных данных (далее — Согласие) разработано в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — ФЗ-152) и определяет порядок обработки персональных данных субъектов персональных данных.
          </Typography>
          <Typography variant="body1" paragraph>
            Оператор обеспечивает соблюдение прав и свобод субъектов персональных данных при обработке их персональных данных, в том числе защиту права на неприкосновенность частной жизни, личную и семейную тайну.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            2. Цели обработки персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            Оператор обрабатывает персональные данные в следующих целях:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Заключение и исполнение договора аренды/бронирования</li>
            <li>Обработка заявок и обращений пользователей</li>
            <li>Информирование о услугах, специальных предложениях и акциях</li>
            <li>Подтверждение бронирования и связи с клиентом</li>
            <li>Выполнение обязательств по договору</li>
            <li>Улучшение качества сервиса</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            3. Перечень персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            В зависимости от целей обработки, Оператор может обрабатывать следующие персональные данные:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li><strong>Фамилия, имя, отчество</strong></li>
            <li><strong>Номер телефона</strong></li>
            <li><strong>Адрес электронной почты (email)</strong></li>
            <li><strong>Данные документа, удостоверяющего личность</strong> (при заключении договора)</li>
            <li><strong>Адрес регистрации</strong> (при заключении договора)</li>
            <li><strong>Дата рождения</strong> (при заключении договора)</li>
            <li><strong>IP-адрес и cookie-файлы</strong> (при использовании сайта)</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            4. Правовые основания обработки
          </Typography>
          <Typography variant="body1" paragraph>
            Обработка персональных данных осуществляется на основании следующих правовых оснований, предусмотренных ст. 6 и ст. 9 ФЗ-152:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li><strong>п. 5 ч. 1 ст. 6 ФЗ-152</strong> — обработка необходима для исполнения договора, стороной которого является субъект персональных данных</li>
            <li><strong>п. 1 ч. 1 ст. 6 ФЗ-152</strong> — обработка осуществляется с согласия субъекта персональных данных</li>
            <li><strong>п. 2 ч. 1 ст. 6 ФЗ-152</strong> — обработка необходима для достижения целей, предусмотренных законом</li>
            <li><strong>ч. 2 ст. 9 ФЗ-152</strong> — получено согласие субъекта персональных данных</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            5. Принципы обработки персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            Оператор обеспечивает соответствие обработки персональных данных следующим принципам (ст. 5 ФЗ-152):
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Обработка осуществляется на законной и справедливой основе</li>
            <li>Обработка ограничивается достижением конкретных, заранее определённых целей</li>
            <li>Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в разных целях</li>
            <li>Обработке подлежат только персональные данные, которые отвечают целям их обработки</li>
            <li>Содержание и объём обрабатываемых персональных данных соответствуют заявленным целям обработки</li>
            <li>При обработке обеспечиваются точность, достаточность, а в необходимых случаях — актуальность персональных данных</li>
            <li>Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            6. Порядок обработки персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.1.</strong> Оператор проводит обработку персональных данных с использованием средств автоматизации и/или без использования таких средств.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.2.</strong> Оператор не принимает решений, порождающих юридические последствия в отношении субъекта персональных данных, на основании исключительно автоматизированной обработки персональных данных.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.3.</strong> Оператор обеспечивает ограничение обработки персональных данных достижением конкретных, заранее определённых целей.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            7. Сроки обработки и хранения персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>7.1.</strong> Срок обработки персональных данных определяется достижением целей обработки или отзывом согласия субъектом персональных данных.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>7.2.</strong> Персональные данные подлежат уничтожению либо обезличиванию по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>7.3.</strong> Сроки хранения персональных данных:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Данные бухгалтерского учёта — 5 лет</li>
            <li>Договоры аренды — 5 лет после окончания срока действия</li>
            <li>Данные бронирований — 3 года</li>
            <li>Email-подписка — до отписки</li>
            <li>Комментарии и отзывы — до удаления субъектом</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            8. Защита персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>8.1.</strong> Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных (ст. 19 ФЗ-152).
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>8.2.</strong> Меры по обеспечению безопасности персональных данных включают:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Определение угроз безопасности персональных данных</li>
            <li>Применение организационных и технических мер по обеспечению безопасности</li>
            <li>Оценку вреда, который может быть причинён субъектам персональных данных</li>
            <li>Установление правил доступа к персональным данным</li>
            <li>Контроль за принимаемыми мерами по обеспечению безопасности</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            9. Права субъекта персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            Субъект персональных данных имеет следующие права (ст. 14 ФЗ-152):
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li><strong>Право на получение информации</strong> об условиях обработки, наличии персональных данных, их источнике</li>
            <li><strong>Право на доступ</strong> к своим персональным данным</li>
            <li><strong>Право на уточнение</strong> неточных персональных данных</li>
            <li><strong>Право на блокирование</strong> персональных данных</li>
            <li><strong>Право на уничтожение</strong> персональных данных</li>
            <li><strong>Право на отзыв согласия</strong> на обработку персональных данных</li>
            <li><strong>Право на обжалование</strong> действий или бездействия оператора в уполномоченный орган или суд</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            10. Отзыв согласия
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>10.1.</strong> Субъект персональных данных может отозвать согласие на обработку персональных данных, направив соответствующий запрос Оператору:
          </Typography>
          <Typography variant="body1" paragraph sx={{ pl: 4 }}>
            По email: admin@domik72.ru
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>10.2.</strong> При отзыве согласия Оператор прекращает обработку персональных данных и уничтожает их в срок, не превышающий 30 дней с даты поступления отзыва, за исключением случаев, когда законодательством установлены обязательные сроки хранения.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            11. Передача персональных данных третьим лицам
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>11.1.</strong> Оператор не осуществляет передачу персональных данных третьим лицам, за исключением случаев, предусмотренных законодательством Российской Федерации.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>11.2.</strong> Передача персональных данных возможна в следующих случаях:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>С согласия субъекта персональных данных</li>
            <li>В целях исполнения договора (например, передача данных в сервисы бронирования)</li>
            <li>В целях обеспечения работы сайта (хостинг-провайдеры, аналитика)</li>
            <li>По запросу уполномоченных государственных органов в соответствии с законодательством</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            12. Файлы cookie и аналитика
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.1.</strong> Сайт Оператора использует файлы cookie и сервисы веб-аналитики (Яндекс.Метрика) для улучшения качества сервиса и анализа посещаемости.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.2.</strong> Cookie-файлы — это небольшие текстовые файлы, сохраняемые на устройстве пользователя при посещении сайта.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.3.</strong> Пользователь может отключить использование cookie в настройках своего браузера, однако это может повлиять на функциональность сайта.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Информация для связи
          </Typography>
          <Typography variant="body1" paragraph>
            Для реализации своих прав, получения информации о персональных данных или отзыва согласия, пожалуйста, свяжитесь с нами:
          </Typography>
          <Typography variant="body1">
            <strong>Email:</strong> <Link href="mailto:admin@domik72.ru">admin@domik72.ru</Link>
          </Typography>
          <Typography variant="body1">
            <strong>Телефон:</strong> +7 (963) 060-02-55
          </Typography>
          <Typography variant="body1">
            <strong>Адрес сайта:</strong> <Link href="https://domik72.ru">domik72.ru</Link>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="body2" color="text.secondary" paragraph>
            <strong>Примечание:</strong> Подробная информация о политике обработки персональных данных доступна в разделе <Link href="/privacy">Политика конфиденциальности</Link>.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="body2" color="text.secondary" align="center">
            Дата публикации: {new Date().toLocaleDateString('ru-RU')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ConsentPage;
